import { render } from "./ShapeSlide.vue?vue&type=template&id=b8b164bc&ts=true"
import script from "./ShapeSlide.vue?vue&type=script&lang=ts"
export * from "./ShapeSlide.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__